module.exports = __webpack_public_path__ + "img/icon2.95c7e17b.svg";